const specialPromotionStyle = Object.freeze({
  fontSize: -1,
  primary: Object.freeze({
    button: 'neutralOpaque',
    icon: [ 'secondary', ],
  }),
  primaryInverse: Object.freeze({
    button: 'secondary',
    icon: [ 'tertiary', '-4', ],
  }),
});

export default specialPromotionStyle;
